<div class="login--container">
    <div class="login-content--form-container mat-elevation-z3">
        <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmitted()">
            <div class="form-content--field-container">
                <h1 class="centered-text">Login</h1>
                @if(errorMessage && loginForm.get('email')?.value == '') {
                    <span>{{errorMessage}}</span>
                }
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Email" formControlName="email">
                    @if(loginForm.get('email')?.hasError('required')) {
                        <mat-error>Email is required</mat-error>
                    }@else if (loginForm.get('email')?.hasError('email')) {
                        <mat-error>Email is not valid</mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Password" formControlName="password" type="password">
                    @if(loginForm.get('password')?.hasError('required')) {
                        <mat-error>Password is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-actions--button-contaienr">
                <button mat-raised-button class="blue-button" type="submit" [disabled]="loginForm.invalid">LOGIN</button>
                <a href="/register"><button mat-stroked-button type="button" class="white-button">REQUEST A LOGIN</button></a>
            </div>
        </form>
    </div>
    <div>
        <span>As a prerequisite to viewing the information on Peak's website, I agree to comply with all applicable privacy laws and to keep all proprietary information, all nonpublic personal information, and any other confidential information that I view or acquire on Peak's website, confidential. I understand that by logging in, I agree with these terms. </span>
    </div>
    <div class="login-content--hint-wrapper">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title> Hint #1 </mat-panel-title>
                </mat-expansion-panel-header>
                <p>If you have not downloaded the password list, <a href="/files/PASSWORD_LIST.txt" download>do so here</a>. If you did, procede to the next hint.</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title> Hint #2 </mat-panel-title>
                </mat-expansion-panel-header>
                <p>BurpSuite is a handy tool to automating requests</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title> Hint #3 </mat-panel-title>
                </mat-expansion-panel-header>
                <a href="https://portswigger.net/web-security/authentication/password-based#username-enumeration">https://portswigger.net/web-security/authentication/password-based#username-enumeration</a>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title> Hint #4 - Solution</mat-panel-title>
                </mat-expansion-panel-header>
                <ol>
                    <li>You should have already gotten the valid email address from step one</li>
                    <li>Download the password list to your downloads directory</li>
                    <li>Launch BurpSuite</li>
                    <li>Depending on your BurpSuite configuration, either launch the BurpSuite browser or use a Browser Extension</li>
                    <li>Browswer -> Fill out the valid email from step one. Put in any random password you want</li>
                    <li>BurpSuite -> Proxy Tab -> Turn on intercept to start capturing traffic</li>
                    <li>Browser -> Click register button to submit the form</li>
                    <li>BurpSuite -> You should see /api/users/login OPTIONS requet -> Forward</li>
                    <li>You should see /api/users/login POST requet -> Right Click -> Send to Intruder</li>
                    <li>Toggle off the proxy intercept off -> Go to Intruder tab</li>
                    <li>Highlight the password you used inside the double quotes -> Click the 'Add S' button next to POSITIONS to make it a position variable</li>
                    <li>In the 'Payload Configuration' section click load -> Selet the PASSWORD_LIST.txt file</li>
                    <li>In the 'Payload Encoding' section, toggle off URL Encoding</li>
                    <li>Click the Start Attack button -> Wait for the attack to finish -> Sort be response codes</li>
                    <li>There is one response code of 200 for password <code>mustang</code>. Use the valid email and this password to login and get the flag</li>
                </ol>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>